import formatGroupedValues from "../utils/formatGroupedValues";

export const CLIENT_POSITIONS_SORT_OPTIONS = [{ value: "name", label: "Name" }];

export const CLIENT_POSITIONS_DEFAULT_FILTERS = {
  filterDivision: [],
  showDeleted: false,
  sortBy: "name",
  sortDirection: "asc",
};

export function buildClientPositionsFilterChips({ filterDivision = [], showDeleted }, { divisionOptions = [] } = {}) {
  const chips = [];
  if (filterDivision.length > 0) {
    const labelFor = (id) => divisionOptions.find((o) => String(o.id) === String(id))?.name || String(id);
    chips.push({ id: "division", key: "filterDivision", fieldId: "positions-division", label: `Division: ${formatGroupedValues(filterDivision, labelFor, 3)}` });
  }
  if (showDeleted) chips.push({ id: "deleted", key: "showDeleted", fieldId: "positions-show-deleted", label: "Show Deleted" });
  return chips;
}
